/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContainerGraphNodeDto
 */
export interface ContainerGraphNodeDto {
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphNodeDto
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphNodeDto
     */
    entityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphNodeDto
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerGraphNodeDto
     */
    hop?: number;
}

/**
 * Check if a given object implements the ContainerGraphNodeDto interface.
 */
export function instanceOfContainerGraphNodeDto(value: object): value is ContainerGraphNodeDto {
    return true;
}

export function ContainerGraphNodeDtoFromJSON(json: any): ContainerGraphNodeDto {
    return ContainerGraphNodeDtoFromJSONTyped(json, false);
}

export function ContainerGraphNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerGraphNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'label': json['label'] == null ? undefined : json['label'],
        'hop': json['hop'] == null ? undefined : json['hop'],
    };
}

export function ContainerGraphNodeDtoToJSON(json: any): ContainerGraphNodeDto {
    return ContainerGraphNodeDtoToJSONTyped(json, false);
}

export function ContainerGraphNodeDtoToJSONTyped(value?: ContainerGraphNodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'label': value['label'],
        'hop': value['hop'],
    };
}

